module.exports = __webpack_public_path__ + "fonts/HalisR-ExtraLight.1c13d3d4.otf";